import * as React from 'react';
import { observer } from 'mobx-react';
import { DecisionDispatcher } from 'nomst/Stores/Decision/decision.dispatcher';
import './sidePanelToggleButton.scss';

export interface ISidePanelToggleButtonProps {
    sidePanelIsOpen: boolean;
    decisionDispatcher: Nullable<DecisionDispatcher>;
}

export class SidePanelToggleButton extends React.Component<ISidePanelToggleButtonProps> {
    constructor(props: ISidePanelToggleButtonProps) {
        super(props);

        this.handleToggle = this.handleToggle.bind(this);
    }

    render(): React.ReactNode {
        return (
            <div className={this.toggleButtonClasses}>
                <button
                    className="view-teams pxl-link"
                    onClick={this.handleToggle}
                >
                    <i className={this.toggleIconClasses} />View Teams
                </button>
            </div>
        );
    }

    private get toggleButtonClasses(): string {
        const { sidePanelIsOpen } = this.props;
        return sidePanelIsOpen ? 'toggle-button toggle-button--open' : 'toggle-button toggle-button--closed';
    }

    private get toggleIconClasses(): string {
        const { sidePanelIsOpen } = this.props;
        return sidePanelIsOpen ? 'icon icon-down-open' : 'icon icon-up-open';
    }

    private handleToggle(): void {
        const { decisionDispatcher, sidePanelIsOpen } = this.props;
        decisionDispatcher?.dispatchSidePanelToggled(!sidePanelIsOpen);
    }
}

export default observer(SidePanelToggleButton);